var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderAudioSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "placeholder_audio_small",
    transform: "matrix(0.25, 0, 0, 0.25, -245.75, -17.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 400,
    height: 400,
    fill: "#dcdcdc",
    x: 983,
    y: 69
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon:_Audio",
    "data-name": "Icon: Audio",
    d: "M 1087 161 C 1073.745 161 1063 171.745 1063 185 L 1063 353 C 1063 366.255 1073.745 377 1087 377 L 1279 377 C 1292.255 377 1303 366.255 1303 353 L 1303 185 C 1303 171.745 1292.255 161 1279 161 L 1087 161 Z M 1165 269 C 1141.907 269.002 1127.474 294.002 1139.022 314.002 C 1150.569 334.001 1179.436 333.999 1190.983 313.998 C 1193.565 309.526 1194.949 304.463 1195 299.298 L 1195 229.012 L 1225 229.012 L 1225 209 L 1175.001 209 L 1175.001 270.8 C 1171.794 269.636 1168.412 269.028 1165 269 Z",
    fill: "#737373",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderAudioSmall);
export default __webpack_public_path__ + "static/media/placeholder_audio_small.457a6d84192c929d381b40dc6d79cab0.svg";
export { ForwardRef as ReactComponent };